import React, { useRef } from "react";
import "../../styles/Home-module.css";
import "./PrintComponents.css";
import { formattedDate, linkPath, linkPathReport } from "../../share/helper";
import { formateDateClient } from "../../share/helper";
import { getCurrentUser } from "../../share/getProfile";

import { FooterPagePrint } from "../letter/FooterPagePrint";
import decorationImage from "../../assets/decoration.png";
export default class ComponentToPrint extends React.Component {
  render() {
    const {
      reason,
      transfer_in_name1,
      transfer_in_name2,
      transfer_in_name3,
      transfer_out_name1,
      transfer_out_name2,
      transfer_out_name3,
      date_start,
      date_end,
      location,
      postion_signature,
      org_cover_by,
      do_in_provinceName,
      date_document,
      org_type_code,
      location_contact,
      org_type_string,
      Org_ImagePath,
    } = this.props;
    const OrgProfile = getCurrentUser();
    const moment = require("moment");
    require("@thyrith/momentkh")(moment);
    let api_date_document = moment(date_document, "YYYY-MM-DD");

    let khmerDateDocument = api_date_document.toLunarDate();

    const spaces = " ".repeat(10); // Creates a string with 20 spaces
    const spaces1 = " ".repeat(1);
    const tilte1 = spaces + "ខ្ញុំបាទ" + transfer_in_name1;
    const title2 = spaces1 + "ត្រូវទៅ" + reason + spaces1 + " នៅ" + location;
    const tilte3 = spaces + "ក្នុងអំឡុងពេលអវត្តមាន ខ្ញុំសូមផ្ទេរសិទ្ធជូន " + transfer_out_name1;
    const title_out =
      transfer_out_name3 +
      " ឲ្យទទួលដឹកនាំចរន្តការងារប្រចាំថ្ងៃជំនួសខ្ញុំ ចាប់ពី" +
      date_start +
      spaces1 +
      "រហូតដល់ខ្ញុំមានវត្តមានការងារវិញ ។";

    const Header = () => {
      return (
        <div className="page_rightmanager_fontmoul">
          <div
            className="text-overlay"
            style={{
              top: 30,
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="page_rightmanager_fontmoul">
              <span>ព្រះរាជាណាចក្រកម្ពុជា</span> <br />
              <span>ជាតិ សាសនា ព្រះមហាក្សត្រ</span>
              <br />
              <img
                src={decorationImage}
                alt="decoration"
                style={{ width: "13%" }}
              />
            </div>
          </div>
          <div
            className="text-overlay"
            style={{
              marginLeft: 50,
              top: 80,
              display: "flex",
              width: "100%",
              alignItems: "start",
            }}
          >
            <div style={{ textAlign: 'start' }}>
              <img
                src={Org_ImagePath}
                alt="Organization Logo"
                style={{ marginLeft: '20px', width: "80px", height: "80px", marginBottom: "5px" }}
              /><br />
              <span>
                {OrgProfile.org_type <= 2 && (
                  <span className="page_rightmanager_fontmoul">
                    <br /> រដ្ឋបាលខេត្ត{OrgProfile.province_name} <br />
                  </span>
                )}
                {OrgProfile.org_type >= 4 && (
                  <span className="page_rightmanager_fontmoul">
                    <br /> មន្ទីរសុខាភិបាលនៃរដ្ឋបាលខេត្ត <br />
                  </span>
                )}
              </span>

              {OrgProfile.org_type != 1 && (
                <span className="page_rightmanager_fontmoul">
                  {OrgProfile.org_cover_by} <br />
                </span>
              )}
              <span className="page_rightmanager_fontmoul">
                {OrgProfile.org_name_kh}
              </span>
              <br />
              <span className="page_rightmanager-fontcontent">
                លេខ៖
              </span><span style={{ fontFamily: 'Content' }}>.........................</span>
            </div>
          </div>


          <div
            className="text-overlay"
            style={{
              top: 270,
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="page_rightmanager_fontmoul">
              {/* <span>{OrgProfile.org_name_kh}</span> */}
              <br />
              <span>លិខិតផ្ទេរសិទ្ធ</span>
              <br />
              <img
                src={decorationImage}
                alt="decoration"
                style={{ width: "13%" }}
              />
              {/* <span>លោកប្រធាន{org_cover_by}</span> */}
              {/* <span>{org_type_string}</span> */}
            </div>
          </div>
        </div>
      );
    };

    return (
      <div>
        <Header />
        <FooterPagePrint location_contact={location_contact} />
        <div
          className="text-overlay"
          style={{ top: 350, left: 90, marginRight: 100 }}
        >
          <table  >
            <tr  >
              <td >
                <div style={{ lineHeight: "2", textAlign: 'start', textAlign: 'justify' }}>
                  <span style={{
                    fontSize: '14px',
                    fontFamily: 'Content'
                  }}>
                    &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; {tilte1}</span>
                  <span style={{
                    fontSize: '14px',
                    fontFamily: 'Content'
                  }}>
                    {transfer_in_name2}
                  </span>
                  <span style={{
                    fontSize: '14px',
                    fontFamily: 'Content'
                  }}>{transfer_in_name3}
                    {title2}</span>
                </div>

                <div style={{ marginTop: '20px', lineHeight: "2", textAlign: 'start', textAlign: 'justify' }}>
                  <span style={{

                    fontSize: '14px',
                    fontFamily: 'Content'
                  }} >
                    &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;{tilte3}
                  </span>
                  <span style={{
                    fontSize: '14px',
                    fontFamily: 'Content'
                  }}>
                    {transfer_out_name2}
                  </span>
                  <span style={{
                    fontSize: '14px',
                    fontFamily: 'Content'
                  }}>
                    {title_out}
                  </span>

                </div>
              </td>
            </tr>
            <tr>

              <td>
                <div
                  style={{
                    marginLeft: 250,
                    display: "flex",
                    justifyContent: "flex-end",

                  }}
                >
                  <div
                    style={{

                      display: "flex",
                      justifyContent: "center", // center horizontally
                      alignItems: "center",     // center vertically
                      flexDirection: "column",  // stack lines vertically
                      width: "100%",
                      height: "200px",          // set your desired height
                      textAlign: "center",      // center text inside each line
                    }}
                  >
                    <span style={{
                      fontSize: '14px',
                      fontFamily: 'Content'
                    }}>{khmerDateDocument}</span>
                    <span style={{
                      fontSize: '14px',
                      fontFamily: 'Content'
                    }}>
                      ធ្វើនៅ{OrgProfile.province_name}
                      {formattedDate(formateDateClient(date_document))}
                    </span>
                    <span style={{
                      fontSize: '14px',
                      fontFamily: 'Content'
                    }}>
                      {postion_signature}
                    </span>
                  </div>


                </div>
              </td>
            </tr>
            <tr>
              <td  >
                <div style={{
                  marginTop: 200,
                  textAlign: 'start'
                }}>
                  <span style={{
                    fontSize: '14px',
                    fontFamily: 'Content'
                  }}>
                    ចំម្លងជូន:
                  </span><br />
                  <span>
                    - {org_cover_by} (ដើម្បីជូនជ្រាប)
                  </span><br />
                  <span>
                    - គ្រប់ផ្នែកចំណុះ {OrgProfile.org_name_kh}<br />
                    - សាម៉ីខ្លួន <br />
                    - ឯកសារ-កាលប្បវត្តិ
                  </span>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div className="text-overlay"></div>
      </div>
    );
  }
}
